import React from "react";
import { Button, Input, Textarea, Typography } from "@material-tailwind/react";
import HeroSection from "./HeroSection";

export default function ContactUs() {
  return (
    <section className="px-8 py-8 lg:py-16">
      <div className="container mx-auto text-center items-center">
        <HeroSection title={"We're Here to Help"} decription={"Whether it is a question about our services, a request for technical assistance, or suggestions for improvement, our team is eager to hear from you."} className="text-white"/>
        
        <div className="grid grid-cols-1 gap-x-12 gap-y-6 lg:grid-cols-2 items-center">
          <img
            src="https://media.wired.com/photos/59269cd37034dc5f91bec0f1/master/pass/GoogleMapTA.jpg"
            alt="map"
            className="w-auto h-full lg:max-h-[415px] cursor-pointer mx-auto"
          />
          <form
            action="#"
            className="flex flex-col gap-4 lg:max-w-sm mx-auto"
          >
           
       
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Typography
                  variant="small"
                  className="mb-0 text-left font-medium bg-transparent text-text"
                >
                  First Name
                </Typography>
                <Input
                  color="gray"
                  size="lg"
                  placeholder="First Name"
                  name="first-name"
                  className="focus:border-t-text focus:border-2"
                  containerProps={{
                    className: "!min-w-full mt-2 z-11",
                  }}
                  labelProps={{
                    className: "hidden",
                  }}
                />
              </div>
              <div>
                <Typography
                  variant="small"
                  className="mb-2 text-left font-medium !text-text"
                >
                  Last Name
                </Typography>
                <Input
                  color="gray"
                  size="lg"
                  placeholder="Last Name"
                  name="last-name"
                  className="focus:border-t-text focus:border-2"
                  containerProps={{
                    className: "!min-w-full",
                  }}
                  labelProps={{
                    className: "hidden",
                  }}
                />
              </div>
            </div>
            <div>
              <Typography
                variant="small"
                className="mb-2 text-left font-medium !text-text"
              >
                Your Email
              </Typography>
              <Input
                color="gray"
                size="lg"
                placeholder="name@email.com"
                name="email"
                className="focus:border-t-text"
                containerProps={{
                  className: "!min-w-full",
                }}
                labelProps={{
                  className: "hidden",
                }}
              />
            </div>
            <div>
              <Typography
                variant="small"
                className="mb-2 text-left font-medium !text-text"
              >
                Your Message
              </Typography>
              <Textarea
                rows={6}
                color="gray"
                placeholder="Message"
                name="message"
                className="border-gray-300 outline-none focus:border-t-text "
                containerProps={{
                  className: "!min-w-full",
                }}
                labelProps={{
                  className: "hidden",
                }}
              />
            </div>
            <Button className="w-full" color="gray">
              Send message
            </Button>
          </form>
        </div>
      </div>
    </section>
  );
}
